import { Row } from '@/ui/primatives';
import { TEvaluationModel } from '@/lib/evaluationModelsApi';
import * as Styled from './styled';
import * as Icon from '@/ui/Icon';

const ModalityTags: React.FC<{ model: TEvaluationModel }> = ({ model }) => {
  const modalities = model.capabilities.input.flatMap((icap) =>
    model.capabilities.output.map((ocap) => ({ input: icap, output: ocap })),
  );
  return (
    <Row gap={10} style={{ flexWrap: 'wrap' }}>
      {modalities.map((modality) => (
        <Styled.ModalityTag key={`${model.id}-${modality.input}-${modality.output}`}>
          {modality.input}
          <Icon.ArrowRight />
          {modality.output}
        </Styled.ModalityTag>
      ))}
    </Row>
  );
};

export default ModalityTags;
